import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { Instagram, Mail } from 'lucide-react';
export function SiteFooter() {
  return <footer className="bg-bodybg border-t border-darkgray pt-20 pb-10" data-id="element-2596">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-2597">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-16" data-id="element-2598">
          {/* Brand Col */}
          <div className="md:col-span-5" data-id="element-2599">
            <Link to="/" className="inline-block mb-6" data-id="element-2600">
              <Logo className="w-16 h-16" data-id="element-2601" />
            </Link>
            <h3 className="font-serif text-2xl text-white mb-4" data-id="element-2602">
              Structure provides the foundation for success.
            </h3>
            <p className="text-sm text-[#9CA3AF] leading-relaxed max-w-sm" data-id="element-2603">
              Jack Achenbach, MS, RDN, CPT specializes in metabolic health,
              GLP-1 nutrition, and sustainable weight management.
            </p>
          </div>

          {/* Links Col */}
          <div className="md:col-span-3 md:col-start-7" data-id="element-2604">
            <h4 className="text-[10px] font-bold text-[#9A9A90] uppercase tracking-[0.25em] mb-6" data-id="element-2605">
              Navigation
            </h4>
            <ul className="space-y-4" data-id="element-2606">
              {[{
              name: 'Home',
              path: '/'
            }, {
              name: 'About',
              path: '/about'
            }, {
              name: 'Services',
              path: '/services'
            }, {
              name: 'Training',
              path: '/training'
            }, {
              name: 'Shop',
              path: '/shop'
            }, {
              name: 'Books',
              path: '/books'
            }, {
              name: 'Contact',
              path: '/contact'
            }].map(link => <li key={link.name} data-id="element-2607">
                  <Link to={link.path} className="text-sm text-[#D8D8D0] hover:text-white transition-colors" data-id="element-2608">
                    {link.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {/* Contact Col */}
          <div className="md:col-span-3" data-id="element-2609">
            <h4 className="text-[10px] font-bold text-[#9A9A90] uppercase tracking-[0.25em] mb-6" data-id="element-2610">
              Connect
            </h4>
            <ul className="space-y-4" data-id="element-2611">
              <li data-id="element-2612">
                <a href="mailto:jack@jackachenbach.com" className="flex items-center gap-3 text-sm text-[#D8D8D0] hover:text-white transition-colors group" data-id="element-2613">
                  <Mail className="w-4 h-4 text-tealslate group-hover:text-lightteal transition-colors" data-id="element-2614" />
                  jack@jackachenbach.com
                </a>
              </li>
              <li data-id="element-2615">
                <a href="#" className="flex items-center gap-3 text-sm text-[#D8D8D0] hover:text-white transition-colors group" data-id="element-2616">
                  <Instagram className="w-4 h-4 text-tealslate group-hover:text-lightteal transition-colors" data-id="element-2617" />
                  @jackachenbach
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-darkgray pt-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-2618">
          <p className="text-xs text-[#7A7A70]" data-id="element-2619">
            © {new Date().getFullYear()} Jack Achenbach, MS, RDN, CPT. All
            rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-[#7A7A70]" data-id="element-2620">
            <Link to="#" className="hover:text-[#D8D8D0] transition-colors" data-id="element-2621">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-[#D8D8D0] transition-colors" data-id="element-2622">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}